import ArrayUtils from '@/utils/arrayUtils'

export default
{
    namespaced: true,
    
    state:
    {
        card: {},
        latestCredits: [],
        latestRewards: [],
    },

    getters:
    {
        getCumuledBalance: state =>
        {
            var b = 0
            if (!state.card.balance) return b

            for (const s of state.card.balance)
            {
                b += s.points
            }

            return b
        }
    },

    mutations:
    {
        setCard (state, card) 
        {
            state.card = card
        },

        updateLatestCredits (state, credits) 
        {
            var merged = ArrayUtils.mergeArrays(state.latestCredits, credits, (a, b) => a.transactionId == b.transactionId)
        
            merged = merged.sort((a, b) =>
            {
                let dDate = new Date(b.timestamp) - new Date(a.timestamp)
                let dId = b.id - a.id

                return dDate + dId
            })

            state.latestCredits = merged
        },

        updateLatestRewards (state, rewards) 
        {
            var merged = ArrayUtils.mergeArrays(state.latestRewards, rewards, (a, b) => a.transactionId == b.transactionId)
        
            merged = merged.sort((a, b) =>
            {
                let dDate = new Date(b.timestamp) - new Date(a.timestamp)
                let dId = b.id - a.id

                return dDate + dId
            })

            state.latestRewards = merged
        }
    },
}


// WEBPACK FOOTER //
// ./src/stores/loyaltyCard.js